import { getMySpaceInteriorCatalogs } from "../../../api/partner/partnerFeatureApis";

const COUNT_PAGE_SIZE = 50;
const COUNT_MAX_PAGES = 4;

/**
 * Total of the partner's own catalogs. The API returns no totals, so pages are fetched until a short page
 * comes back. If the cap is reached the count is honest about it ("200+").
 * Resolves to a display string.
 */
export const loadMyCatalogCount = async (token, userId) => {
  let total = 0;
  for (let page = 1; page <= COUNT_MAX_PAGES; page += 1) {
    const data = await getMySpaceInteriorCatalogs(token, { userId, page_number: page, page_size: COUNT_PAGE_SIZE });
    if (data?.statusType && data.statusType !== "SUCCESS") throw new Error(data.text || "Failed to load catalogs");
    const length = (data?.catalogs || []).length;
    total += length;
    if (length < COUNT_PAGE_SIZE) return String(total);
  }
  return `${total}+`;
};
